module.exports = __webpack_public_path__ + "static/albuquerque-plumbing-logo-43d9b410c55cde162481e8b42a47986f.svg";